import DOMPurify from "dompurify";

export default function sanitize(data: string){
    return DOMPurify.sanitize(data);
};
